import { render, staticRenderFns } from "./Wp_join_robot_button_model.vue?vue&type=template&id=3576909e&scoped=true&"
import script from "./Wp_join_robot_button_model.vue?vue&type=script&lang=js&"
export * from "./Wp_join_robot_button_model.vue?vue&type=script&lang=js&"
import style0 from "./Wp_join_robot_button_model.vue?vue&type=style&index=0&id=3576909e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3576909e",
  null
  
)

export default component.exports